import { X_GRID_EMPHASIS_COLOR, X_GRID_POINT_COLOR } from 'utils';
import { GRAPH_AXYS } from '../../utils';
import { IChartPoint } from '../../models';

const Y_AXIS_MARGIN = 5;
export const Y_AXIS_MAX = GRAPH_AXYS.max + Y_AXIS_MARGIN;
export const Y_AXIS_MIN = GRAPH_AXYS.min - Y_AXIS_MARGIN;
export const CHART_Y_RANGE = Y_AXIS_MAX - Y_AXIS_MIN;
export const X_AXES_DEFAULT_MIN = 35;
export const X_AXES_DEFAULT_MAX = 75;
export const VALUE_TO_USE_MIN_DEFAULT = 40;
export const VALUE_TO_USE_MAX_DEFAULT = 70;
export const X_AXES_STEP = 5;
export const AREAS_COUNT = 3; // red, yellow and green area
export const AREA_LABEL_Y_OFFSET = 20;
export const WORD_HALF_HEIGHT = 10;
export const CHART_TOP_PADDING = 35;
export const CHART_LEFT_PADDING = 40;

const LINE_HEIGHT = 1.15;
const LABEL_LINE_HEIGHT_PX = 12;
export const LABEL_HEIGHT_PX = LABEL_LINE_HEIGHT_PX * LINE_HEIGHT * 2;
export const POINT_OFFSET_PX = 13;
// LABEL_OFFSET_PX is POINT_OFFSET_PX without POINT_BORDER_WIDTH_PX and some value
// that represents small height because of the line height
export const LABEL_OFFSET_PX = 8;
export const LINE_DASH = [5, 10];
export const MAX_ONE_LINE_STRING_SYMBOLS = 13;
export const POINT_RADIUS_PX = 12;
export const POINT_BORDER_WIDTH_PX = 2;
export const SUM_POINT_RADIUS_PX = POINT_RADIUS_PX + POINT_BORDER_WIDTH_PX;

export const POINTS = {
	point: {
		backgroundColor: X_GRID_POINT_COLOR,
		borderColor: '#383838',
		borderWidth: POINT_BORDER_WIDTH_PX,
	},
};

export const EMPHASIS_POINTS = {
	point: {
		backgroundColor: X_GRID_EMPHASIS_COLOR,
		borderColor: '#383838',
		borderWidth: POINT_BORDER_WIDTH_PX,
	},
};

export const PADDING = {
	padding: {
		top: CHART_TOP_PADDING,
		left: CHART_LEFT_PADDING,
	},
};

export const PRIORITY_LABELS = {
	labels: {
		priority: {
			align: 'center' as const,
			font: { size: 14 },
			formatter(value: IChartPoint) {
				return value.priority;
			},
			display: true,
		},
	},
};

export const LABELS_STYLE = {
	color: 'black',
	textAlign: 'center' as const,
	offset: POINT_OFFSET_PX,
	labels: {
		title: {
			font: {
				size: 12,
				lineHeight: 1.15,
			},
		},
	},
};

export const PRIORITY_LABELS_STYLE = {
	color: 'rgba(0,0,0,0.25)',
	textAlign: 'center' as const,
	offset: POINT_OFFSET_PX,
	labels: {
		title: {
			font: {
				size: 12,
				lineHeight: 1.15,
			},
		},
	},
};

export const getScaleLabel = (label: string) => {
	return {
		display: true,
		labelString: label,
		fontColor: 'black',
		fontSize: 18,
		fontFamily: 'DIN',
	};
};

export const Y_AXES_GRID_LINES = {
	borderDash: [5, 5],
	drawBorder: false,
	zeroLineColor: 'transparent',
	display: false,
};

export const Y_AXES_TICKS = {
	min: Y_AXIS_MIN,
	max: Y_AXIS_MAX,
	display: false,
};
